import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import { $neutralGray50 } from '../../../../../styles/colors/primitives'
import Img from '../../../../Img'

function LiteFormulaWheelCompatibility({ title, text, image }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.title}>
          <SimpleBlockContent
            blocks={title.text}
            highlight={title.highlight}
            highlightSx={`color: ${$neutralGray50};`}
            highlightExactMatch={true}
            noSpace
          />
        </div>
        {
          image && (
            <div className={styles.imageWrapper}>
              {/* task #67: image is now a ResolvedImage descriptor */}
              <Img
                image={image}
                alt={title.text}
                layout="fill"
                objectFit="contain"
              />
            </div>
          )
        }
        <div className={styles.textBody}>
          <SimpleBlockContent blocks={text} noSpace/>
        </div>
      </div>
    </div>
  )
}

export default LiteFormulaWheelCompatibility
